document.addEventListener("DOMContentLoaded", () => {
  const banner = document.querySelector("[data-line-floating-banner]");
  const closeButton = document.querySelector("[data-line-floating-close]");

  if (!banner) return;

  const STORAGE_KEY = "lineFloatingBannerClosedAt";
  const HIDE_DURATION = 7 * 24 * 60 * 60 * 1000; // 1週間

  const closedAt = localStorage.getItem(STORAGE_KEY);

  const isWithinHidePeriod =
    closedAt && Date.now() - Number(closedAt) < HIDE_DURATION;

  let isClosed = Boolean(isWithinHidePeriod);

  const toggleBanner = () => {
    if (isClosed) {
      banner.classList.remove("is-show");
      return;
    }

    if (window.scrollY > 300) {
      banner.classList.add("is-show");
    } else {
      banner.classList.remove("is-show");
    }
  };

  closeButton?.addEventListener("click", () => {
    isClosed = true;
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
    banner.classList.remove("is-show");
  });

  window.addEventListener("scroll", toggleBanner, { passive: true });

  toggleBanner();
});

// document.addEventListener("DOMContentLoaded", () => {
//   const banner = document.querySelector("[data-line-floating-banner]");
//   const closeButton = document.querySelector("[data-line-floating-close]");

//   if (!banner) return;

//   let isClosed = false;

//   const toggleBanner = () => {
//     if (isClosed) return;

//     if (window.scrollY > 300) {
//       banner.classList.add("is-show");
//     } else {
//       banner.classList.remove("is-show");
//     }
//   };

//   closeButton?.addEventListener("click", () => {
//     isClosed = true;
//     banner.classList.remove("is-show");
//   });

//   window.addEventListener("scroll", toggleBanner, { passive: true });

//   toggleBanner();
// });
